<template>
    <div>
      <el-container>
        <el-header>
          <head_page :head_page_type=false ref="head_page"></head_page>
        </el-header>
  
        <el-main>
          <div id='choose_city' style="backgroundColor: white">
            <head_menu :has-back=true @go-back-click="goBack">
              <template #title>
                <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:5px;font-size: 20px;">
                  <!-- {{chosen_city=='first'?'Global':chosen_city}} -->
                </div>
              </template>
             
            </head_menu>
        
          </div>
          <div>
            <el-row>
              <el-col :span = 7>
                <div style=" font-size: 18px;color: #254A6E;padding: 0px;margin-top: 10px;margin-bottom: 10px;font-weight: 600;">User that have the authority of cross-city </div>
                <el-table
                  :data="user_list"
                  highlight-current-row
                  @row-click = "getCrossCityUser"
                  :header-cell-style="rowClass"
                  height="800"
                  border
                  style="width: 100%"
                 
              >
                <el-table-column
                  prop="name"
                  :label="$t('message.name')"
                  width="180"
                  ></el-table-column>
                  <el-table-column
                  prop="bu"
                  :label="$t('message.BU')"
                  width="180"
                  ></el-table-column>
                
                  </el-table>
              </el-col>
              <el-col :span = 1></el-col>
              <el-col :span = 10>
                <div v-if="user != ''" style=" font-size: 18px;color: #254A6E;padding: 0px;margin-top: 10px;margin-bottom: 10px;font-weight: 600;">cross-city proposals from  {{ user }}</div>
               <div style="margin:20px; border-style: dotted;border-width: 3px;border-color: rgb(77, 182, 172);" v-for="item in statistic_list">
                <div>client_name:{{ item.client_name }}</div>
                <div v-for="(ele,index) in item.city">city :{{ ele}}</div>
              </div>
              </el-col>
            </el-row>
          </div>
      </el-main>
  
      </el-container>
    </div>
  </template>
  
  <script>
  import head_page from "./components/head_page.vue";
  import head_menu from './components/head_menu.vue';
  import axios from "axios";
  import _global from "./components/global.vue";
  import DoughnutChart from './components/DoughnutChart.js';
  import echarts from 'echarts';
  import parseUtil from './utils/parseUtils.vue'
  import VGauge from "vgauge";
  export default {
    name: "statistics",
    mixins: [parseUtil],
    data() {
      return {
        user_list:[],
        statistic_list:[],
        user:''
      }
      
    },
    components: {
      head_page,
      head_menu,
      DoughnutChart,
      VGauge,
    },
     watch: {
      // "proposal_loading":{
      //   handler(new_value,old_value){
      //     if (new_value == false && old_value == true){
      
      
      //      // this.getEcharts()
      //     }
      //   }
      // },
    
    },
    created() {
    
    },
    mounted() {
      this.$refs.head_page.update_user_name();
      this.getData()
      this.lang = JSON.parse(sessionStorage.getItem("lang"));
      
     
    },
   
    methods: {
      rowClass({ rowIndex, columnIndex }) {
        if (rowIndex === 0) {       
          return {background:'#254A6E',color:'white'}        
        }
      },
      


      
      getCrossCityUser(row){
        this.user = row.name
        let api_url = _global.serverSrc + "/users_crosscity_statistic/" + "?user=" + row.name;
            let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
            this.$axios
                .post(api_url, obj)
                .then((response) => {

                  for(let i = 0; i < response.data.statistic.length; i++) {
                    response.data.statistic[i].city = response.data.statistic[i].city.split(",")
                    response.data.statistic[i].city.pop()
                  }
                  this.statistic_list = response.data.statistic
                  
              
                })
      },
    
        getData(){
            let api_url = _global.serverSrc + "/users_crosscity_authority/" + "?chosen_city=" + 0;
            let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
            this.$axios
                .post(api_url, obj)
                .then((response) => {
               this.user_list = response.data.person

              
                })
        },
      goBack() {
        this.$router.back();
      },
    
    },
    computed: {}
     
  };
  </script>
  <style>
    .el-table__body >.tr.current-row{
     background-color: #254A6E;
    }
    .el-tabs--border-card > .el-tabs__content {
      padding-top: 0px !important;
      padding-left:0px !important;
      padding-right:0px !important;
  }
  </style>
  <style lang="scss" scoped>
  </style>